export default __webpack_public_path__ + "static/media/C0007.4db57a54.png";